import { render } from "./EventModal.vue?vue&type=template&id=2efacc60&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"

import "./EventModal.vue?vue&type=style&index=0&id=2efacc60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efacc60"]])

export default __exports__